<template>
  <article class="index">
    <div class="main_banner">
      <div class="dwnld_button">
        <router-link to="/downloads" class="download_button base_link">Скачать лаунчер</router-link>
      </div>
    </div>
    <div class="news index_container">
      <div class="news_title base_title">Новости</div>
      <div class="news_body" v-if="news">
        <div class="news_body-card" v-for="post in news" :key="post.uid">
          <div class="news_body-cover">
            <img :src="`/s/${post.image}`" alt="PostCover" class="base_image">
          </div>
          <div class="news_body-info">
            <div class="news_body-column">
              <div class="news_body-title">{{ post.title }}</div>
              <div class="news_body-posted">{{ normalDate(post.posted) }}</div>
            </div>
            <div class="news_body-column">
              <div class="news_body-full">
                <router-link :to="{ name: 'Post', params: { uid: post.uid } }">
                  <mIcon name="external" :width="24" :heigth="24" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="news_empty" v-else>
        <div class="news_empty-icon"></div>
        <div class="news_empty-text">Новостей пока нет, ожидайте обновлений.</div>
      </div>
      <div class="news_add" v-if="$store.getters.admin">
        <router-link to="/new-post" class="base_link">
          <button type="button" class="btn download_button">Добавить новость</button>
        </router-link>
      </div>
    </div>
  </article>
</template>
<script>
import Backend from '../services/backend.service';
import mIcon from '../components/materialIcon';

export default {
  name: 'Index',
  components: { mIcon },
  data() {
    return {
      backend: new Backend(),
      news: null,
    };
  },
  methods: {
    getNews() {
      this.backend.get('/posts')
        .then((resp) => {
          if (resp.length >= 1) {
            this.news = resp;
          }
        })
        .catch(err => console.error(err));
    },
    normalDate(timestamp) {
      const date = new Date();
      const posted = new Date(timestamp * 1000);
      const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа',
        'сентября', 'октября', 'ноября', 'декабря'];
      const month = months[posted.getMonth()];
      const thisYear = posted.getFullYear() === date.getFullYear();
      return thisYear ? `${posted.getDate()} ${month}` : `${posted.getDate()} ${month} ${posted.getFullYear()}`;
    },
  },
  mounted() {
    this.getNews();
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
.index{
  .main_banner{
    position: relative;
    aspect-ratio: 16 / 9;
    width: 100%;
    background: url('/static/main-banner.jpg') no-repeat 50% 50% / cover;
    .dwnld_button{
      position: absolute;
      display: flex;
      top: 310px;
      left: calc(50% - 64px);
      font-family: $font;
      color: white;
    }
  }
  .news{
    position: relative;
    &_body{
      display: flex;
      align-items: center;
      justify-content: space-around;
      min-height: 250px;
      position: relative;
      padding: 40px 0;
      &:before{
        width: 100%;
        height: 100%;
        position: absolute;
        content: '';
        background: url('/static/news-bg.png') repeat-y 50% 0%;
        mix-blend-mode: luminosity;
        z-index: 0;
      }
      &-card{
        padding: 0;
        z-index: 2;
        border-radius: 10px;
        background: $dark-black;
      }
      &-cover{
        aspect-ratio: 16 / 9;
        height: 200px;
        pointer-events: none;
        border-radius: inherit;
        img {
          border-radius: 10px 10px 0 0 !important;
          object-fit: cover;
        }
      }
      &-info{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 10px 10px 10px;
      }
      &-title{
        font-family: $font;
        font-size: 24px;
      }
      &-posted{
        font-size: 14px;
        opacity: .75;
      }
    }
    &_empty{
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 250px;
      &-icon{
        position: relative;
        width: 87px;
        height: 150px;
        border-radius: 50%;
        margin-right: 40px;
        &:after{
          position: absolute;
          display: block;
          content: '';
          width: 100%;
          height: 100%;
          background: url('/static/empty-icon.png') no-repeat 50% 50% / contain;
        }
        &:before{
          position: absolute;
          content: '';
          width: 100%;
          height: 100%;
          background: rgba(42, 164, 54, 0.18);
          filter: blur(30px);
        }
      }
    }
    &_add{
      position: relative;
      display: flex;
      z-index: 2;
      justify-content: center;
      margin-bottom: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue